import { Notification } from '@progress/kendo-react-notification'
import { useEffect, useRef, useState } from 'react'
import {
  useSurveyCtx,
  useSurveyCtxDispatch,
} from '../../../Context/SurveyContext'
import { millisecondsToSeconds } from 'date-fns'
import { useIdleTimer } from 'react-idle-timer'
import { JwtPayload, jwtDecode } from 'jwt-decode'
import { OpenAPI } from '../../../api'

interface TimerProps {
  studyId: number
  panelistId: number
  postSurvey: boolean
  timeOutMS: number
  refreshToken: (studyID: number, panelistID: number,postSurvey:boolean) => void
  abandonSurvey?: (SurveyInstanceId: string) => void
}

export const Timer = (props: TimerProps) => {
  const [reminingSeconds, setRemainingSeconds] = useState(30)
  const [alertTimeout, setAlertTimeout] = useState(false)
  const surveyCtx = useSurveyCtx()
  const surveyCtxDispatch = useSurveyCtxDispatch()

  let promptInterval = useRef<NodeJS.Timeout>()
  let refreshInterval= useRef<NodeJS.Timeout>()

  useEffect(() => {
    function refreshToken() {
      if (OpenAPI.TOKEN) {
        let decodedToken: JwtPayload = jwtDecode(OpenAPI.TOKEN.toString())
        let token: Date = new Date(decodedToken.exp! * 1000)
        let current: Date = new Date()
        //console.log("Interval tokenExp: "+decodedToken.exp!);
        const tokenExpInSeconds = (token.getTime() - current.getTime()) / 1000
        //console.log("TokenExpiration Sec:"+tokenExpInSeconds);
        //console.log("Prompt Remaining Sec:"+millisecondsToSeconds(getRemainingTime()));
        if (tokenExpInSeconds <= 30) {
          //reset();
          props.refreshToken(props.studyId, props.panelistId,props.postSurvey)
        }
      }
    }

    refreshInterval.current = setInterval(refreshToken, 10000)
    return () => {
      clearInterval(refreshInterval.current)
      clearInterval(promptInterval.current)
    }
  }, [props])

  function abandonSurvey() {
    if (OpenAPI.TOKEN) {
      if (!props.postSurvey && props.abandonSurvey) {
        props.abandonSurvey(`SID_S${props.studyId}_P${props.panelistId}`)
      }
    }
  }

  const onPrompt = () => {
    console.log('prompt')
    if (!surveyCtx.IsTimeOut) {
      //console.log(`You are Prompt. Remining Seconds: ${millisecondsToSeconds(getRemainingTime())}`)
      setRemainingSeconds(millisecondsToSeconds(getRemainingTime()))
      promptInterval.current = setInterval(() => {
        setRemainingSeconds(millisecondsToSeconds(getRemainingTime()))
      }, 1000)
      setAlertTimeout(true)
    }
  }

  const onIdle = () => {
    //console.log("Idle");
    if (!surveyCtx.IsTimeOut) {
      //console.log(`You are Timedout. Remining Seconds: ${millisecondsToSeconds(getRemainingTime())}`)
      surveyCtxDispatch({ type: 'setTimeout', value: true })
      abandonSurvey()
      setAlertTimeout(false)
      clearInterval(refreshInterval.current)
      clearInterval(promptInterval.current)

    }
  }

  const onActive = () => {
    //console.log("active");
    clearInterval(promptInterval.current)
    props.refreshToken(props.studyId, props.panelistId,props.postSurvey)
  }

  const onAction = () => {
    //console.log(event);
    if (!surveyCtx.IsTimeOut && alertTimeout) {
      activate()
      setAlertTimeout(false)
    }
  }
  const { getRemainingTime, activate } = useIdleTimer({
    onPrompt,
    onIdle,
    onActive,
    onAction,
    timeout: props.timeOutMS > 61_000 ? props.timeOutMS : 61_000,
    promptBeforeIdle: props.timeOutMS > 60_000 ? 60_000 : props.timeOutMS - 1,
    throttle: 500,
    events: [
      'mousemove',
      'keydown',
      'wheel',
      'DOMMouseScroll',
      'mousewheel',
      'mousedown',
      'touchstart',
      'touchmove',
      'MSPointerDown',
      'MSPointerMove',
      'visibilitychange',
      'focus',
    ],
  })

  return (
    <div className="theme-survey-alert">
      {alertTimeout && (
        <Notification
          className="min-w-full w-full theme-alert mb-5"
          // type={{ style: 'warning' }}

          aria-live="polite"
          aria-describedby=" Your session will expire in 30 seconds."
        >
          <div className="text-sm basis-full w-full">
            Your session will expire in {reminingSeconds} seconds due to
            inactivity.
          </div>
        </Notification>
      )}
    </div>
  )
}
